import { ComponentProps } from "react"
import { Clock } from "@phosphor-icons/react"
import { Input } from "@/components/ui/input"
import { cn } from "@/lib/utils"
import { validTimeWhileTypingRegex } from "@/modules/admin/news/constants"

interface NewsTimeInputProps extends Omit<ComponentProps<typeof Input>, "value" | "onChange" | "type"> {
  value?: string
  onChange: (time: string) => void
}

export const NewsTimeInput = ({ value, onChange, onBlur, className, ...inputProps }: NewsTimeInputProps) => {
  const handleChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const typedTime = evt.target.value
    if (validTimeWhileTypingRegex.test(typedTime)) onChange(typedTime)
  }

  const handleBlur = (evt: React.FocusEvent<HTMLInputElement>) => {
    const completedTime = completeTypedTime(value ?? "")
    if (completedTime !== value) onChange(completedTime)
    onBlur?.(evt)
  }

  return (
    <Input
      {...inputProps}
      type="text"
      inputMode="numeric"
      maxLength={5}
      placeholder="HH:mm"
      className={cn("focus:placeholder:text-on-surface-subdued pr-12 placeholder:text-transparent", className)}
      value={value ?? ""}
      onChange={handleChange}
      onBlur={handleBlur}>
      <Clock className="text-on-surface-subdued pointer-events-none absolute top-3 right-4 z-2 h-6 w-6" />
    </Input>
  )
}

const completeTypedTime = (typedTime: string) => {
  const [hours, minutes = ""] = typedTime.includes(":")
    ? typedTime.split(":")
    : [typedTime.slice(0, 2), typedTime.slice(2)]
  if (!hours) return typedTime
  return `${hours.padStart(2, "0")}:${minutes.padStart(2, "0")}`
}
